/*
  Winkelwagen v2 (zijbalk). Hoort bij snippets/cart-hoort-erbij.liquid en
  snippets/cart-drawer-onderkant.liquid.

  1. "Erbij": legt de aanvulling in de wagen met de verborgen eigenschap
     _bron = winkelwagen, zodat in de orders te tellen is wat hier vandaan kwam,
     en laat de drawer zichzelf opnieuw tekenen.
  2. Bezorgdag in de beloftes, met dezelfde regels als de klok op de
     productpagina: ma t/m do voor 17:00 morgen, vr voor 17:00 zaterdag,
     vr na 17:00 en het weekend dinsdag.

  Klikken lopen via document, want de drawer vervangt zijn HTML bij elke update.
*/
(function () {
  'use strict';

  if (window.ldwCartV2) return;
  window.ldwCartV2 = true;

  var DAGEN = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

  function bezorgtekst(nu) {
    var dag = nu.getDay();
    var na = nu.getHours() >= 17;
    if (dag >= 1 && dag <= 4) return na ? DAGEN[(dag + 2) % 7] + ' in huis' : 'Morgen in huis';
    if (dag === 5) return na ? 'Dinsdag in huis' : 'Zaterdag in huis';
    return 'Dinsdag in huis';
  }

  function vulBezorgdag() {
    var tekst = bezorgtekst(new Date());
    tekst = tekst.charAt(0).toUpperCase() + tekst.slice(1);
    document.querySelectorAll('[data-ldw-lever]').forEach(function (el) {
      if (el.textContent !== tekst) el.textContent = tekst;
    });
  }

  document.addEventListener('click', function (event) {
    var knop = event.target.closest('[data-ldw-erbij]');
    if (!knop) return;
    event.preventDefault();
    if (knop.classList.contains('is-loading')) return;
    knop.classList.add('is-loading');

    var drawer = document.querySelector('cart-drawer');
    var secties = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];

    fetch(window.routes.cart_add_url + '.js', Object.assign({}, fetchConfig('javascript'), {
      body: JSON.stringify({
        items: [{
          id: Number(knop.dataset.ldwErbij),
          quantity: Number(knop.dataset.ldwAantal) || 1,
          properties: { _bron: 'winkelwagen' }
        }],
        sections: secties.filter(function (id, i) { return secties.indexOf(id) === i; }),
        sections_url: window.location.pathname
      })
    }))
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || 'toevoegen mislukt');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        knop.classList.remove('is-loading');
      });
  });

  document.addEventListener('DOMContentLoaded', function () {
    vulBezorgdag();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(vulBezorgdag).observe(drawer, { childList: true, subtree: true });
    }
  });
})();
